import React from "react";

const BetaBlockerNote = () => {
  return (
    <div className="bg-white p-2  flex flex-col max-w-[259px] ">
      <p className="text-gray-800 text-sm  font-normal">
        Also used for chest pain, heart failure, irregular heartbeats, and recovery after a heart attack.
      </p>
    </div>
  );
};

export default BetaBlockerNote;
